(() => {
  const popup = document.getElementById('nm-popup');
  if (!popup) return;
  const KEY = 'nm_popup_seen';
  const now = Date.now();
  const success = !!popup.querySelector('[data-nm-success]');
  const force = new URLSearchParams(location.search).has('popup');
  const blocked = location.pathname.includes('/cart') || location.pathname.includes('/checkout');

  const suppressed = () => {
    try { const v = JSON.parse(localStorage.getItem(KEY) || 'null'); return v && v > now; } catch { return false; }
  };
  const suppress = () => {
    try { localStorage.setItem(KEY, JSON.stringify(now + 30 * 24 * 60 * 60 * 1000)); } catch { /* ignore */ }
  };

  let lastFocus = null;
  const open = (skipSuppress) => {
    if (!popup.hasAttribute('hidden')) return;
    lastFocus = document.activeElement;
    popup.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    const f = popup.querySelector('input, button');
    if (f) f.focus();
    if (!skipSuppress) suppress();
  };
  const close = () => {
    popup.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  };

  popup.querySelectorAll('[data-nm-close]').forEach((el) => el.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !popup.hasAttribute('hidden')) close(); });
  popup.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || popup.hasAttribute('hidden')) return;
    const f = [...popup.querySelectorAll('a[href],button,input,[tabindex]:not([tabindex="-1"])')].filter((x) => !x.disabled && x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  if (success) { open(); return; }            // returned from a successful signup — show the code
  if (force) { open(true); return; }          // ?popup=1 — force-show for QA (skips suppression + delay)
  if (blocked || suppressed()) return;

  let done = false;
  const trigger = () => { if (done) return; done = true; open(); cleanup(); };
  const onMouseOut = (e) => { if (e.clientY <= 0) trigger(); };
  const timer = setTimeout(trigger, Number(popup.dataset.delay) || 8000);
  document.addEventListener('mouseout', onMouseOut);
  function cleanup() { clearTimeout(timer); document.removeEventListener('mouseout', onMouseOut); }
})();
